export type BloodCrimesTvLiveTrack = {
  id: string;
  title?: string | null;
  genre?: string | null;
  mood?: string | null;
  approved?: number | boolean | null;
  live_allowed?: number | boolean | null;
  liveAllowed?: boolean | null;
  rights_status?: string | null;
};

export type BloodCrimesTvLivePlaylist = { id: string; title: string; status?: string };

export const BLOODCRIMES_TV_LIVE_PRESETS = [
  { id: 'bc-case-files-long', name: 'BloodCrimes Case Files · Long', theme: 'True crime case files · documentary stories', contentMode: 'CASE_FILES', musicTerms: [], visualTerms: [] },
  { id: 'bc-midnight-jazz', name: 'BC Midnight Jazz', theme: 'Dark jazz · mafia noir · late-night lounge', musicTerms: ['jazz', 'noir'], visualTerms: ['jazz', 'mafia', 'casino', 'lounge'] },
  { id: 'bc-night-drive', name: 'BC Night Drive', theme: 'Night drive synthwave · neon city · rainy highway', musicTerms: ['synthwave', 'night drive', 'electronic'], visualTerms: ['highway', 'drive', 'rainy', 'harbor'] },
  { id: 'bc-underground-club', name: 'BC Underground Club', theme: 'Underground electronic · dark club beats · neon night', musicTerms: ['electronic', 'industrial', 'club'], visualTerms: ['club', 'underground', 'casino'] },
  { id: 'bc-rainy-city-lofi', name: 'BC Rainy City Lo-Fi', theme: 'Rainy city lo-fi · dark ambient · late-night relaxation', musicTerms: ['lofi', 'lo-fi', 'ambient', 'rain'], visualTerms: ['rain', 'city', 'street', 'harbor'] },
] as const;

function matchesTerms(value: string, terms: readonly string[]) {
  const normalized = value.toLocaleLowerCase().replace(/[·,|]+/g, ' ');
  return terms.some((term) => normalized.includes(term));
}

export function recommendBloodCrimesTvLivePresetMedia(
  presetId: string,
  tracks: BloodCrimesTvLiveTrack[],
  playlists: BloodCrimesTvLivePlaylist[],
) {
  const preset = BLOODCRIMES_TV_LIVE_PRESETS.find((item) => item.id === presetId);
  if (!preset) return { preset: null, musicIds: [], playlistId: '' };
  if ('contentMode' in preset && preset.contentMode === 'CASE_FILES') return { preset, musicIds: [], playlistId: '' };
  const musicIds = tracks.filter((track) => {
    const approved = track.approved === 1 || track.approved === true;
    const liveAllowed = track.live_allowed === 1 || track.live_allowed === true || track.liveAllowed === true;
    return approved && liveAllowed && track.rights_status?.toUpperCase() === 'APPROVED'
      && matchesTerms(`${track.title ?? ''} ${track.genre ?? ''} ${track.mood ?? ''}`, preset.musicTerms);
  }).map((track) => track.id);
  const playlist = playlists.find((item) => item.status === 'APPROVED' && matchesTerms(item.title, preset.visualTerms));
  return { preset, musicIds, playlistId: playlist?.id ?? '' };
}
